import { gql } from "@apollo/client";

export const LIST_BANKS = gql`
  query listBanks($filter: BankFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listBanks(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
        companyId
        accountingFirmId
      }
    }
  }
`;

export const LIST_COMPANY_BANK_ACCOUNTS = gql`
  query listCompaniesBankAccountsPaginated(
    $filter: CompanyBankFilter
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listCompaniesBankAccountsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        iban
        bic
        bankDescription
        name
        sepaCredentialIdentifier
        isMain
        currency
        isActive
      }
    }
  }
`;

export const DELETE_CLIENT_BANK = gql`
  mutation deleteClientBankAccount($id: ID!) {
    deleteClientBankAccount(id: $id) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_CLIENT_BANK = gql`
  query getClientBankAccount($id: ID!) {
    getClientBankAccount(id: $id) {
      id
      bic
      iban
      id
      isActive
      isMain
      bankDescription
      name
      currency
      company {
        id
      }
    }
  }
`;

export const LIST_CLIENT_BANKS = gql`
  query listClientBankAccountsPaginated(
    $filter: ClientBankAccountFilter
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listClientBankAccountsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        iban
        bic
        bankDescription
        isMain
        isActive
        name
      }
    }
  }
`;

export const CREATE_CLIENT_BANK = gql`
  mutation createClientBankAccount($input: CreateClientBankAccountInput!) {
    createClientBankAccount(input: $input) {
      clientBankAccount {
        id
        iban
        bic
        bankDescription
        isMain
        isActive
        name
        currency
        company {
          id
        }
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_CLIENT_BANK = gql`
  mutation updateClientBankAccount($input: UpdateClientBankAccountInput!) {
    updateClientBankAccount(input: $input) {
      clientBankAccount {
        id
        iban
        bic
        bankDescription
        isMain
        isActive
        company {
          id
        }
      }
      errors {
        field
        messages
      }
    }
  }
`;
